import { gql } from '@apollo/client';

const GetReferralLink = gql`
  query GetReferralLink($campaignId: String!, $email: AWSEmail!) {
    getReferralLink(campaignId: $campaignId, email: $email)
  }
`;

export default GetReferralLink;
